import {useEffect, useRef} from 'react'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'

import {useAppSelector} from '../../../../../hooks/react-redux'
import {useRefetchablePreloadedQuery} from '../../../../../hooks/relay/useRefetchablePreloadedQuery'
import {useThrottle} from '../../../../../hooks/useThrottle'
import {getBuild} from '../../../../../selectors'

import type {TestScopesViewQuery} from './__generated__/TestScopesViewQuery.graphql'
import {testScopesViewQuery} from './TestScopesView.queries'

const THROTTLER_TIMEOUT = 5000

export const useTestScopes = (props: {
  scopeName: string
  locator: string
  buildId: number
  preloadedQuery: PreloadedQuery<TestScopesViewQuery>
}) => {
  const {scopeName, locator, buildId, preloadedQuery} = props
  const [{testScopes = null}, refetch] = useRefetchablePreloadedQuery(
    testScopesViewQuery,
    preloadedQuery,
  )
  const count = useAppSelector(state => getBuild(state, buildId)?.testOccurrences?.count)
  const fetchTestScopesWithThrottle = useThrottle(refetch, THROTTLER_TIMEOUT)

  const isMountedRef = useRef(false)

  const refetchArgs = useRef({scopeName, locator})
  refetchArgs.current = {
    scopeName,
    locator,
  }

  useEffect(() => {
    if (isMountedRef.current) {
      // Call your throttled refetch here if count changes and it's not the first render
      fetchTestScopesWithThrottle(refetchArgs.current)
    } else {
      isMountedRef.current = true
    }
  }, [count, fetchTestScopesWithThrottle])

  return testScopes
}
